import { Button } from '@monorepo/shared/componentsV2/Button';
import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { BaseModal } from '@monorepo/shared/componentsV2/modals/BaseModal';
import { ModalFormInstructions } from '@monorepo/shared/componentsV2/modals/contents/ModalFormInstructions';
import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { useFormTemplateContext } from '../../EditFormTemplatePage/FormTemplateContext';
import { MoveInspectionDateField } from './MoveInspectionDateField';

type MoveInspectionDateModalFormValues = {
  groupSlug: string;
};

export type EditFieldModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onMoveInspectionDate: (newGroupSlug: string) => void;
};

export function MoveInspectionDateModal({
  isOpen,
  onClose,
  onMoveInspectionDate,
}: EditFieldModalProps) {
  const {
    formTemplateHelpers: { inspectionDateField },
  } = useFormTemplateContext();

  const onSubmit = useCallback(
    ({ groupSlug }: MoveInspectionDateModalFormValues) => {
      if (!groupSlug) return;
      onMoveInspectionDate(groupSlug);
      onClose();
    },
    [onMoveInspectionDate, onClose],
  );

  if (!inspectionDateField) return null;

  return (
    <Form<MoveInspectionDateModalFormValues> onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <BaseModal
          title="Move Field"
          open={isOpen}
          onClose={onClose}
          maxWidth="sm"
          buttons={
            <Button
              color="primary"
              onClick={handleSubmit}
              type="submit"
              variant="contained"
            >
              Move field
            </Button>
          }
        >
          <ErrorBoundary>
            <ModalFormInstructions>
              Choose a new section for the {inspectionDateField.name} field.
            </ModalFormInstructions>
            <MoveInspectionDateField />
          </ErrorBoundary>
        </BaseModal>
      )}
    </Form>
  );
}
